module.exports = __webpack_public_path__ + "img/search-references.4f6815f4.svg";